import { aiCreditsConsumptionApi } from "@circle-react/api/aiCreditsConsumptionApi";
import { creditsApi } from "@circle-react/api/credits/creditsApi";
import { createQueryKeyFactory } from "@circle-react/lib/queries/createQueryKeyFactory";
import { queryClient } from "@circle-react/providers/QueryClient/reactQueryConfig";
import type { AiCreditsBillingData } from "@circle-react/types/UsageBilling";
import { queryOptions } from "react-query";

export const creditBalanceKey = createQueryKeyFactory("credits");

export const creditBalanceQueries = {
  balance: () =>
    queryOptions({
      queryKey: creditBalanceKey.key("balance"),
      queryFn: creditsApi.balance,
    }),
};

export const aiCreditsDailyConsumptionKey = createQueryKeyFactory(
  "ai-credits-daily-consumption",
);

export const aiCreditsDailyConsumptionQueries = {
  byPeriod: (startDate: string, endDate: string) =>
    queryOptions({
      queryKey: aiCreditsDailyConsumptionKey.key({ startDate, endDate }),
      queryFn: () =>
        aiCreditsConsumptionApi.fetchDailyConsumption({
          start_date: startDate,
          end_date: endDate,
        }),
    }),
};

export const creditBalanceInvalidations = {
  all: () =>
    queryClient.invalidateQueries({ queryKey: creditBalanceKey.root() }),
};

export const setCreditBalanceCache = (balance: AiCreditsBillingData) => {
  queryClient.setQueryData(creditBalanceKey.key("balance"), balance);
};

export const CREDITS_EXHAUSTED_ERROR = "credits_exhausted";

export const markCreditsExhausted = () => {
  queryClient.setQueryData<AiCreditsBillingData | undefined>(
    creditBalanceKey.key("balance"),
    prev =>
      prev
        ? {
            ...prev,
            usage: {
              ...prev.usage,
              available_credits: 0,
              used_credits: prev.usage.total_credits,
              percent_used: 100,
              status: "danger",
              low_on_credits: false,
            },
          }
        : prev,
  );
  void creditBalanceInvalidations.all();
};
